export const SUITS = ['♠', '♥', '♦', '♣'];
export const VALUES = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];

export const SUIT_COLORS = {
  '♠': 'black',
  '♣': 'black',
  '♥': 'red',
  '♦': 'red',
};

export const VALUE_ORDER = {
  'A': 1, '2': 2, '3': 3, '4': 4, '5': 5,
  '6': 6, '7': 7, '8': 8, '9': 9, '10': 10,
  'J': 11, 'Q': 12, 'K': 13,
};

export function createDeck(deckId = 0) {
  const deck = [];
  for (const suit of SUITS) {
    for (const value of VALUES) {
      deck.push({
        id: `${value}${suit}-${deckId}`,
        suit,
        value,
        color: SUIT_COLORS[suit],
        numericValue: VALUE_ORDER[value],
        faceUp: false,
      });
    }
  }
  return deck;
}

export function shuffleDeck(deck) {
  const shuffled = [...deck];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export function dealPlayerHand(deckId = 0) {
  const deck = shuffleDeck(createDeck(deckId));

  const pouncePile = deck.slice(0, 13).map((card, i) => ({
    ...card,
    faceUp: i === 12,
  }));

  const tableau = deck.slice(13, 17).map(card => ({
    ...card,
    faceUp: true,
  }));

  const drawPile = deck.slice(17).map(card => ({
    ...card,
    faceUp: false,
  }));

  return {
    pouncePile,
    tableau,
    drawPile,
    drawDiscard: [],
  };
}

export function canPlayOnFoundation(card, foundationTopCard) {
  if (!foundationTopCard) {
    return card.value === 'A';
  }
  return (
    card.suit === foundationTopCard.suit &&
    card.numericValue === foundationTopCard.numericValue + 1
  );
}

export function canPlayOnTableau(card, tableauTopCard) {
  if (!tableauTopCard) return true;
  return (
    card.color !== tableauTopCard.color &&
    card.numericValue === tableauTopCard.numericValue - 1
  );
}